import confetti from "canvas-confetti";

/** Short celebratory burst after a correct daily guess. */
export function celebrateDailyWin(): void {
  const duration = 1800;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.65 },
      colors: ["#22c55e", "#15803d", "#fbbf24", "#3b82f6", "#ef4444"],
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.65 },
      colors: ["#22c55e", "#15803d", "#fbbf24", "#3b82f6", "#ef4444"],
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  };

  confetti({
    particleCount: 80,
    spread: 70,
    origin: { y: 0.6 },
    colors: ["#22c55e", "#15803d", "#fbbf24", "#3b82f6", "#ef4444"],
  });
  frame();
}
